// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.js-components-css-ErrorModal-module__errorModal{width:320px;font-size:1.1em;padding:5px 11px}`, "",{"version":3,"sources":["webpack://./js/components/css/ErrorModal.module.scss"],"names":[],"mappings":"AAAA,iDACI,WAAA,CACA,eAAA,CACA,gBAAA","sourcesContent":[".errorModal {\n    width: 320px;\n    font-size: 1.1em;\n    padding: 5px 11px;\n}\n"],"sourceRoot":""}]);
// Exports
export var errorModal = `js-components-css-ErrorModal-module__errorModal`;
export default ___CSS_LOADER_EXPORT___;
